import React from 'react'
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import { BaseUrl } from '../../../helper/BaseUrl';
import { fetchJson } from '../../../helper/fetchJson';

const integrationCategories = (integrations) => {
  const uniqueCategories = [
    ...new Set(integrations.map((item) => item.category_name)),
  ];

  return [
    { id: "all", name: "all" },
    ...uniqueCategories.map((cat, index) => ({ id: index, name: cat })),
  ];
};

export default function IntegrationPost({ initialData }) {

  const initialIntegrations = Array.isArray(initialData) ? initialData : [];
  const [searchTerm, setSearchTerm] = useState("");
  const [allData, setAllData] = useState(initialIntegrations);
  const [visibleCount, setVisibleCount] = useState(6);
  const [isLoadMore, setIsLoadMore] = useState(true);
  const [categories, setCategories] = React.useState(() => integrationCategories(initialIntegrations));
  const [activeCategory, setActiveCategory] = React.useState("all");

  // API Calling
  const fetcher = async () => {
    try {
      const result = await fetchJson(`${BaseUrl}/api/tms-integrations`);
      if (result.integrations === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.integrations);
      setCategories(integrationCategories(result.integrations));
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    if (!initialIntegrations.length) fetcher();
  }, [initialIntegrations.length])


  //  Filter (Search + Category)
  const filteredIntegration = allData.filter((item) => {
    const matchesSearch = item.name?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = activeCategory === "all" || item.category_name?.toLowerCase().includes(activeCategory.toLowerCase());
    return matchesSearch && matchesCategory;
  });

  // Reset on Category Change
  useEffect(() => {
    setVisibleCount(6);
    setIsLoadMore(true);
  }, [activeCategory]);

  const handleLoadMore = () => {
    if (visibleCount >= filteredIntegration.length) {
      setVisibleCount(6);
      setIsLoadMore(true);
    } else {
      setVisibleCount((prev) => prev + 3);
      if (visibleCount + 3 >= filteredIntegration.length) {
        setIsLoadMore(false);
      }
    }
  };


  return (
    <section className="integration-post">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-lg-3">
            <div className="post-left">
              <span>Category</span>
              <ul className="integration-category">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link className={activeCategory === cat.name ? "active" : ""} onClick={() => setActiveCategory(cat.name)}   >
                      {cat.name === "all" ? "All Integrations" : cat.name} </Link> </li>))}
              </ul>
            </div>
          </div>
          <div className="col-md-12 col-lg-9">
            <div className="post-right">
              <div className="search-wrapper">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="search-filter">
                      <form className="searchbox-container" onSubmit={(event) => event.preventDefault()}>
                        <input type="search" className="searchbox form-control"
                          placeholder="Search for an integration" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                        <button type="submit" className="search-button">
                          <i className="fa-solid fa-magnifying-glass"></i>
                        </button>
                      </form>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="view-wrap">
                      <strong>Viewing:</strong>{" "}
                      {filteredIntegration.length} All Integration
                    </div>
                  </div>
                </div>
              </div>
              <div className="row post-row">
                {filteredIntegration.slice(0, visibleCount).map((data, index) => (
                  <div className="col-md-4" key={data?._id || index}>
                    <div className="post-col">
                      <div className="icon">
                        <img src={`${BaseUrl}${data?.logo}`} className="img-responsive post-img" alt={data?.name} loading="lazy" />
                      </div>
                      <div className="heading">{data?.name?.slice(0, 30) + "..."}</div>
                      <p dangerouslySetInnerHTML={{ __html: data?.short_description?.slice(0, 200) + "..." }} />
                      <Link className="read-more" to={`${data?.slug}`} >More Details <i className="fa-solid fa-arrow-right"></i> </Link>
                    </div>
                  </div>
                ))}
                <div className="col-md-4 blue-card">
                  <div className="post-col">
                    <div className="post-inner">
                      <span>Get Started</span>
                      <div className="heading">Ready to Build on Our Platform?</div>
                      <p>Access API docs, SDKs, webhooks, and integration guides to build powerful Supply Chain Systems features seamlessly.</p>
                      <Link className="read-more" to={`/about-us`}>Get Started<i className="fa-solid fa-arrow-right"></i> </Link>
                    </div>
                  </div>
                </div>
              </div>
              {filteredIntegration.length > 6 && (
                <div className="row">
                  <div className="col-md-12">
                    <div className="load-more">
                      <Link onClick={handleLoadMore} className="theme-btn"    >
                        <span> {isLoadMore ? "View More" : "View Less"}  </span>
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
